import { Trans } from '@mntn-dev/i18n'
import { Text } from '@mntn-dev/ui-components'
import type React from 'react'

type AppTransProps = React.ComponentProps<typeof Trans> & {
  components?: Record<string, React.ReactNode>
}

const AppTrans = ({ components, ...props }: AppTransProps) => (
  <Trans
    {...props}
    components={{
      // Anything highly re-usable goes here
      primary: <Text textColor="primary" />,
      secondary: <Text textColor="secondary" />,
      // Anything bespoke or configured should be passed in via components props. E.g., a <Link/> with a specific href
      ...(components ?? {}),
    }}
  />
)

export { AppTrans }
